"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceoverToneToJSON = exports.VoiceoverToneFromJSONTyped = exports.VoiceoverToneFromJSON = exports.VoiceoverTone = void 0;
/**
 * The tone of the voiceover. Currently only supported for AI voiceovers.
 * @export
 */
exports.VoiceoverTone = {
    Chill: 'CHILL',
    Conversational: 'CONVERSATIONAL',
    Upbeat: 'UPBEAT'
};
function VoiceoverToneFromJSON(json) {
    return VoiceoverToneFromJSONTyped(json, false);
}
exports.VoiceoverToneFromJSON = VoiceoverToneFromJSON;
function VoiceoverToneFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.VoiceoverToneFromJSONTyped = VoiceoverToneFromJSONTyped;
function VoiceoverToneToJSON(value) {
    return value;
}
exports.VoiceoverToneToJSON = VoiceoverToneToJSON;
